<template>
  <div class="content-box testimonial-item">
    <template v-if="data.imageName">
      <div class="testimonial-item__top-image">
        <v-img
          class="round-image"
          :src="`${apiUrl}/file/public?slug=${slug}&fileName=${data.imageName}`"
        ></v-img>
      </div>
    </template>

    <div class="testimonial-item__header">
      <h2>{{ localize(data.title) }}</h2>
      <strong v-if="localize(data.subtitle)">{{
        localize(data.subtitle)
      }}</strong>
    </div>

    <div class="testimonial-item__text">
      <p>{{ localize(data.text) }}</p>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapState('companyModule', {
      slug: 'slug'
    }),

    ...mapGetters('companyModule', {
      apiUrl: 'currentCompanyApiUrl'
    })
  }
};
</script>
